import React from 'react'
import Hero from '../components/Hero'
import Card from '../components/Card'
import ContactForm from '../components/ContactForm'
import servicesData from '../data/servicesData'
import aboutImg from '../assets/aboutImg.jpeg'
import img5 from '../assets/img5.jpeg'
import img6 from '../assets/img6.jpeg'
import bgImage from '../assets/bgImage.jpg'
import aboutSection2 from '../assets/about-section2.jpg'

const missionPoints = [
  'To impart skill training to young & to assist the elderly and destitute people in the community.',
  'To lift the people out of poverty and to form vital & healthy lives for their families now and for the future.',
  'To fight for the development and sustainability of helpless people and safeguard their basic human rights.',
  'To create a world of tolerance, hope, and social justice for every member of our society.',
]

const statsData = [
  { num:'520', label:'Total Projects' },
  { num:'7',   label:'Vibhag' },
  { num:'27',  label:'Jila' },
  { num:'119', label:'Nagar' },
  { num:'171', label:'Kendra' },
]

export default function Home() {
  return (
    <main>
      <Hero />

      {/* ── About Section ── */}
      <section className="py-20" style={{background:'white'}}>
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <img src={aboutImg} alt="Sewa Bharti community work" className="w-full rounded-2xl object-cover shadow-2xl" style={{height:'460px',boxShadow:'0 32px 80px rgba(13,27,62,0.12)'}}/>
            <div className="absolute bottom-8 right-0 translate-x-4 text-white rounded-2xl px-8 py-6 text-center shadow-2xl"
              style={{background:'var(--saffron)',boxShadow:'0 16px 40px rgba(232,103,10,0.4)'}}>
              <div className="font-bold leading-none" style={{fontFamily:'Playfair Display,serif',fontSize:'44px'}}>46</div>
              <div className="text-sm font-medium mt-1 opacity-90">Years of<br/>Experience</div>
            </div>
          </div>

          <div>
            <div className="section-tag">About Us</div>
            <h2 className="mb-5 leading-tight" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(28px,4vw,42px)',fontWeight:700,color:'var(--navy)'}}>
              Sewa Bharti Haryana<br/>Pradesh
            </h2>
            <p className="mb-4 leading-relaxed" style={{fontSize:'15.5px',color:'var(--muted)'}}>
              <strong style={{color:'var(--text)'}}>Sewa Bharti Haryana</strong> is a non-profit, non-governmental organization that works for the welfare of the people of Haryana, India. Founded in 1980 and headquartered in Karnal, it has over a thousand volunteers working in all districts of the state.
            </p>
            <p className="mb-8 leading-relaxed" style={{fontSize:'15.5px',color:'var(--muted)'}}>
              The organization works in child education, health, skill education, and social welfare. It runs schools, hospitals, vocational training centers, and hostels, and provides relief and rehabilitation during natural disasters.
            </p>
            <div className="grid grid-cols-2 gap-3 mb-8">
              {['Child Education','Healthcare','Skill Development','Social Welfare','Disaster Relief','Community Harmony'].map(p => (
                <div key={p} className="flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium" style={{background:'var(--saffron-pale)',color:'var(--saffron-dark)'}}>
                  <span className="w-2 h-2 rounded-full flex-shrink-0" style={{background:'var(--saffron)'}}/>
                  {p}
                </div>
              ))}
            </div>
            <a href="/about" className="inline-flex items-center gap-2 text-white px-7 py-3.5 rounded-full font-semibold text-sm transition-all hover:-translate-y-0.5"
              style={{background:'var(--saffron)'}}>
              Learn More
              <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
            </a>
          </div>
        </div>
      </section>

      {/* ── Initiatives ── */}
      <section className="py-20" style={{background:`url(${bgImage}) center/cover fixed`, position:'relative'}}>
        <div className="absolute inset-0" style={{background:'rgba(253,250,246,0.93)'}}/>
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="section-tag" style={{justifyContent:'center'}}>Sewa Bharti Haryana Pradesh</div>
            <h2 className="mb-4" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(28px,4vw,44px)',fontWeight:700,color:'var(--navy)'}}>Our Initiatives</h2>
            <p className="mx-auto" style={{fontSize:'16px',color:'var(--muted)',maxWidth:'560px',lineHeight:1.8}}>Transforming lives across Haryana through focused, compassionate programs that address the root causes of poverty and inequality.</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {servicesData.map((s, i) => <Card key={s.slug} {...s} index={i}/>)}
          </div>
        </div>
      </section>

      {/* ── Mission ── */}
      <section className="py-20" style={{background:'white'}}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="rounded-3xl overflow-hidden flex flex-col lg:flex-row shadow-2xl" style={{boxShadow:'0 32px 80px rgba(13,27,62,0.10)'}}>
            <div className="w-full lg:w-1/2">
              <img src={img5} alt="Mission" className="w-full h-full object-cover" style={{minHeight:'380px'}}/>
            </div>
            <div className="w-full lg:w-1/2 p-10 sm:p-14 flex flex-col justify-center" style={{background:'white'}}>
              <div className="section-tag">Our Purpose</div>
              <h2 className="mb-8" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(28px,4vw,42px)',fontWeight:700,color:'var(--navy)'}}>Our Mission</h2>
              <div className="space-y-5">
                {missionPoints.map((text, i) => (
                  <div key={i} className="flex items-start gap-4 p-4 rounded-xl transition-colors" style={{background:'rgba(0,0,0,0.018)'}}>
                    <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0" style={{background:'var(--saffron-pale)'}}>
                      <svg className="w-4.5 h-4.5" fill="none" stroke="var(--saffron)" strokeWidth="2" viewBox="0 0 24 24" width="18" height="18"><polyline points="20 6 9 17 4 12"/></svg>
                    </div>
                    <p className="leading-relaxed text-sm" style={{color:'var(--muted)',paddingTop:'8px'}}>{text}</p>
                  </div>
                ))}
              </div>
              <a href="/contact" className="mt-8 inline-flex items-center gap-2 text-white px-7 py-3.5 rounded-full font-semibold text-sm transition-all hover:-translate-y-0.5 w-fit"
                style={{background:'var(--saffron)'}}>
                Contact Us
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── Stats Banner ── */}
      <section className="py-0" style={{background:`url(${aboutSection2}) center/cover fixed`,position:'relative'}}>
        <div className="absolute inset-0" style={{background:'rgba(13,27,62,0.88)'}}/>
        <div className="relative max-w-7xl mx-auto px-6 py-16">
          <div className="text-center mb-12">
            <div className="section-tag" style={{justifyContent:'center',color:'#FFA55A','--saffron':'#FFA55A'}}>
              <span style={{display:'block',width:'22px',height:'2px',background:'#FFA55A',borderRadius:'2px'}}/>
              Our Reach
              <span style={{display:'block',width:'22px',height:'2px',background:'#FFA55A',borderRadius:'2px'}}/>
            </div>
            <h2 className="text-white" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(26px,4vw,42px)',fontWeight:700}}>Impact Across Haryana</h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            {statsData.map(({ num, label }) => (
              <div key={label} className="text-center rounded-2xl py-8 px-4 transition-all hover:-translate-y-1"
                style={{background:'rgba(255,255,255,0.06)',border:'1px solid rgba(255,255,255,0.08)'}}>
                <div className="font-bold leading-none" style={{fontFamily:'Playfair Display,serif',fontSize:'42px',color:'var(--saffron-light)'}}>{num}</div>
                <div className="text-sm mt-2" style={{color:'rgba(255,255,255,0.45)'}}>{label}</div>
                <div className="w-8 h-0.5 mx-auto mt-3 rounded" style={{background:'var(--saffron)'}}/>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── More About ── */}
      <section className="py-20" style={{background:'white'}}>
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="section-tag">More About</div>
            <h2 className="mb-6 leading-tight" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(28px,4vw,42px)',fontWeight:700,color:'var(--navy)'}}>Sewa Bharti Haryana Pradesh</h2>
            <p className="leading-relaxed" style={{fontSize:'15.5px',color:'var(--muted)'}}>
              With the passage of time, the Sewa work expanded speedily. This selfless social service, with its right nature and intent, became the popular and talking point of the society. Considering the potential and impact of social work, the organization was named as <strong style={{color:'var(--navy)'}}>SEWA BHARTI</strong> and a constitution after detailed deliberations was framed to complete the legal formalities.
            </p>
          </div>
          <div>
            <img src={img6} alt="Sewa Bharti" className="w-full rounded-2xl object-cover" style={{height:'400px',boxShadow:'0 24px 60px rgba(13,27,62,0.12)'}}/>
          </div>
        </div>
      </section>

      {/* ── Contact Form ── */}
      <ContactForm />
    </main>
  )
}
